import firebase from 'firebase';

export const listClasslinkTenants = firebase.functions().httpsCallable('listClasslinkTenants');
export const previewClasslinkTenant = firebase.functions().httpsCallable('previewClasslinkTenant');
export const getClasslinkSettings = firebase.functions().httpsCallable('getClasslinkSettings');
export const saveClasslinkSettings = firebase.functions().httpsCallable('saveClasslinkSettings');
export const runClasslinkSync = firebase.functions().httpsCallable('runClasslinkSync');
export const resolveClasslinkMissing = firebase.functions().httpsCallable('resolveClasslinkMissing');

export default 'Integrations.api.js';
